// Home page
export function renderHome(): string {
  return `
    <div class="home-page">
      <div class="home-hero text-center">
        <div class="hero-icon">♔</div>
        <h1>ChessKid AI</h1>
        <p class="tagline">Belajar catur sambil bermain! 🎮</p>
        <p class="subtitle text-secondary">Dirancang untuk anak-anak dan pemula</p>
      </div>

      <div class="home-menu">
        <a href="#/play" class="menu-card">
          <div class="menu-icon">🎮</div>
          <div class="menu-label">Play</div>
          <div class="menu-desc">Main melawan AI</div>
        </a>
        <a href="#/learn" class="menu-card">
          <div class="menu-icon">📚</div>
          <div class="menu-label">Learn</div>
          <div class="menu-desc">Belajar aturan catur</div>
        </a>
        <a href="#/puzzle" class="menu-card">
          <div class="menu-icon">🧩</div>
          <div class="menu-label">Puzzle</div>
          <div class="menu-desc">Latih taktik catur</div>
        </a>
        <a href="#/stats" class="menu-card">
          <div class="menu-icon">📊</div>
          <div class="menu-label">Statistics</div>
          <div class="menu-desc">Lihat perkembanganmu</div>
        </a>
        <a href="#/clock" class="menu-card">
          <div class="menu-icon">⏱️</div>
          <div class="menu-label">Chess Clock</div>
          <div class="menu-desc">Jam catur dengan timer</div>
        </a>
        <a href="#/settings" class="menu-card">
          <div class="menu-icon">⚙️</div>
          <div class="menu-label">Settings</div>
          <div class="menu-desc">Atur aplikasi</div>
        </a>
      </div>
    </div>
  `;
}

export function initHome(): void {
  // Add active class to nav
  document.querySelectorAll('.nav-links a').forEach(a => a.classList.remove('active'));
}
